import { useSgcqStore } from "@/stores/SgcqStore";
import {
  UP_LOGO,
  DOWN_LOGO,
  UP_IMAGEM,
  DOWN_IMAGEM,
  UP_EQP_IMG,
  DOWN_EQP_IMG,
  UP_PRODUTO_FIG,
  DW_PRODUTO_FIG,
  UP_PROTOCOLO,
  DOWN_PROTOCOLO,
  UP_CRLV,
  DOWN_CRLV,
  UP_STAMP,
  DOWN_STAMP,
} from "@/http/url";

//O Axios apresenta configuração dificil e incompatibilidade com Bootsrap-vue componente
//Por isso foi usado o vue-resource para chamadas de arquivos
export default class Files {
  constructor(http) {
    this._http = http;
    const store = useSgcqStore();
    const token = store.getToken;
    this.config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
  }

  //Carrega e descarrega as imagens das logomarcas dos clientes do backend

  uploadLogo(filename, file) {
    return this._http
      .post(UP_LOGO + filename, file, this.config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  downloadLogo(filename) {
    let config = {
      responseType: "arraybuffer",
      headers: this.config.headers,
      Accept: "application/jpg",
    };
    return this._http
      .get(DOWN_LOGO + filename + ".jpg", config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  //Carrega e descarrega as imagens das logomarcas dos clientes do backend

  uploadImagem(filename, file) {
    return this._http
      .post(UP_IMAGEM + filename, file, this.config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  downloadImagem(filename) {
    let config = {
      responseType: "arraybuffer",
      headers: this.config.headers,
      Accept: "application/jpg",
    };
    return this._http
      .get(DOWN_IMAGEM + filename + ".jpg", config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  //Carrega e descarrega as imagens dos equipamentos do backend

  uploadEquipamento(filename, file) {
    return this._http
      .post(UP_EQP_IMG + filename, file, this.config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  downloadEquipamento(filename) {
    let config = {
      responseType: "arraybuffer",
      headers: this.config.headers,
      Accept: "application/jpg",
    };
    return this._http
      .get(DOWN_EQP_IMG + filename + ".jpg", config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  //Carrega e descarrega as imagens dos produtos para os orcamentos do backend

  uploadProduto(filename, file) {
    return this._http
      .post(UP_PRODUTO_FIG + filename, file, this.config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  downloadProduto(filename) {
    let config = {
      responseType: "arraybuffer",
      headers: this.config.headers,
      Accept: "application/jpg",
    };
    return this._http
      .get(DW_PRODUTO_FIG + filename + ".jpg", config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  //Carrega e descarrega as imagens dos protocolos de saida de equipamento do backend

  uploadProtocolo(filename, file) {
    return this._http
      .post(UP_PROTOCOLO + filename, file, this.config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  downloadProtocolo(filename) {
    let config = {
      responseType: "arraybuffer",
      headers: this.config.headers,
      Accept: "application/jpg",
    };
    return this._http
      .get(DOWN_PROTOCOLO + filename + ".jpg", config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  //Carrega e descarrega o CRLV

  uploadCrlv(filename, file) {
    return this._http
      .post(UP_CRLV + filename, file, this.config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  downloadCrlv(filename) {
    let config = {
      responseType: "arraybuffer",
      headers: this.config.headers,
      Accept: "application/jpg",
    };
    return this._http
      .get(DOWN_CRLV + filename + ".jpg", config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  //Carrega e descarrega o CARIMBOS STAMPS

  uploadStamp(filename, file) {
    return this._http
      .post(UP_STAMP + filename, file, this.config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }

  downloadStamp(filename) {
    let config = {
      responseType: "arraybuffer",
      headers: this.config.headers,
      Accept: "application/png",
    };
    return this._http
      .get(DOWN_STAMP + filename + ".png", config)
      .then((response) => response.data)
      .catch((error) => console.log(error));
  }
}
